import { useBuild } from "app/components/Playground/BuildContext";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { StepListItem } from "./StepListItem";
import { Drawer } from "../Drawer";
import { useCallback } from "react";
import { ErrorBoundary } from "app/lib/Bugsnag";
import { ErrorView } from "app/components/shared/ErrorView";

export const StepDrawer = () => {
  const navigate = useNavigate();
  const { build } = useBuild();
  const { stepId } = useParams();

  if (!build) {
    throw new Error("Missing build context");
  }

  const handleClose = useCallback(() => {
    navigate(`${build.path}/canvas`);
  }, []);

  // The trigger/root step isn't a real step in the pipeline so for now we
  // just ignore it.
  if (stepId === "root") {
    return null;
  }

  const step = build.steps.find((step) => step.uuid === stepId);
  if (!step) {
    return <Navigate to={`${build.path}`} />;
  }

  // TODO: For now it's only command steps.
  if (step.type !== "command") {
    return null;
  }

  return (
    <Drawer onClose={handleClose}>
      <ErrorBoundary FallbackComponent={ErrorView}>
        <StepListItem step={step} />
      </ErrorBoundary>
    </Drawer>
  );
};
